import { render } from "./LandSubdivisionPackagesView.vue?vue&type=template&id=7c222cbe&scoped=true&ts=true&lang=pug"
import script from "./LandSubdivisionPackagesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandSubdivisionPackagesView.vue?vue&type=script&lang=ts&setup=true"

import "./LandSubdivisionPackagesView.vue?vue&type=style&index=0&id=7c222cbe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c222cbe"]])

export default __exports__